import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function MyTeam() {
  const [bots, setBots] = useState([]);
  const [selectedBots, setSelectedBots] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('https://bot-battle-server.vercel.app/bots')
      .then(response => response.json())
      .then(data => setBots(data))
      .catch(error => console.error('Error fetching bots:', error));

    fetch('https://bot-battle-server.vercel.app/selected')
      .then(response => response.json())
      .then(data => setSelectedBots(data))
      .catch(error => console.error('Error fetching selected bots:', error));
  }, []);

  const handleAddToArmy = (bot) => {
    if (!selectedBots.find(selectedBot => selectedBot.id === bot.id)) {
        
      fetch('https://bot-battle-server.vercel.app/selected', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bot),
      })
      .then(response => response.json())
      .then(() => {
        setSelectedBots(prevSelected => [...prevSelected, bot]);
      })
      .catch(error => console.error('Error adding bot to army:', error));
      alert(`Bot says ${bot.catchphrase}`)
    } else {
      alert('This bot is already in your army.');
    }
  };

  const handleShowArmyClick = () => {
    navigate('/my-army');
  };

  return (
    <div className="flex flex-col items-center mt-44 text-black">
      <h1 className="text-3xl mb-4 text-white">My Team</h1>
      <button
        onClick={handleShowArmyClick}
        className="bg-blue-500 text-white p-2 rounded-lg mb-6"
      >
        Show My Army
      </button>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6 mt-6">
        {bots.map(bot => (
          <div key={bot.id} className="bg-slate-200 p-4 rounded-lg shadow-lg text-center">
            
            <img src={bot.avatar_url} alt={bot.name} className="w-full h-48 object-cover rounded-md mb-2" />
            <h3 className="text-xl mb-2">{bot.name}</h3>
            <h3 className="text-xl mb-2">{bot.bot_class}</h3>
            <button
              onClick={() => handleAddToArmy(bot)}
              className="bg-blue-500 text-white p-2 rounded-lg"
            >
              Add to My Army
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MyTeam;
